var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"socks",style:('height:' + _vm.socks_height),attrs:{"id":"socks"}},[_c('svg',{ref:"svg",attrs:{"height":_vm.svgHeight,"width":_vm.svgWidth,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":_vm.viewBox}})])
}
var staticRenderFns = []

export { render, staticRenderFns }